export default __webpack_public_path__ + "static/go-to@mob-f69a17e0d1d74f0058f50706e344252a.svg";